import * as THREE from 'three';
import {db} from './firebaseconfig';
import { collection, getDocs, type QueryDocumentSnapshot, type DocumentData } from 'firebase/firestore';
import Experience from "../Experience";
import PathwayItem from "../World/PathwayItem";
import type { SceneInventoryItem } from "../types/scene";
import { debugLog } from "../Utils/debugLog";

export default class LoadPaths {
    experience: Experience;
    scene: THREE.Scene;
    canvas: HTMLCanvasElement | null;
    camera: THREE.Camera;
    loadedPathways: boolean;
    sceneInventory: SceneInventoryItem[];
    private inventoryLoadPromise: Promise<void> | null;
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas
        this.camera = this.experience.camera.instance;
        this.loadedPathways = false;
        this.sceneInventory = [];
        this.inventoryLoadPromise = null;
        this.inventoryLoadPromise = this.init();
    }
    async init()
    {
        if (this.inventoryLoadPromise) {
            return this.inventoryLoadPromise;
        }
        this.inventoryLoadPromise = this.loadSceneInventory();
        await this.inventoryLoadPromise;
    }
    async ensureSceneInventoryLoaded() {
        if (this.sceneInventory.length > 0) {
            debugLog("[pathways] inventory already loaded", this.sceneInventory.length);
            return;
        }
        if (!this.inventoryLoadPromise) {
            this.inventoryLoadPromise = this.loadSceneInventory();
        }
        debugLog("[pathways] waiting for inventory load");
        await this.inventoryLoadPromise;
    }
    private async loadSceneInventory() {
        try {
            let sceneInventory: SceneInventoryItem[] = await this.fetchSceneInventory();
            const dates = sceneInventory.map((scene) => scene.createdAt?.toDate?.() ?? new Date(0));
            sceneInventory = sceneInventory.filter((scene, index) => {
                const sceneDate = dates[index];
                const juneFirst = new Date('2024-06-01'); // Adjust the year as needed
                return sceneDate >= juneFirst;
            });
            sceneInventory = sceneInventory.filter((scene) => {
                return scene.elementsToRegenerateURL
            });
            await Promise.all(
                sceneInventory.map(async (scene) => {
                    if (!scene.elementsToRegenerateURL) {
                        return;
                    }
                    try {
                        const response = await fetch(scene.elementsToRegenerateURL);
                        if (!response.ok) {
                            throw new Error(
                                `elementsToRegenerate fetch failed (${response.status} ${response.statusText})`
                            );
                        }
                        scene.elementsToRegenerate = await response.json();
                    } catch (error) {
                        console.warn(
                            "Skipping pathway with unavailable storage file:",
                            scene.id,
                            scene.elementsToRegenerateURL,
                            error
                        );
                    }
                })
            );
            debugLog("pathways loaded",sceneInventory);
            this.sceneInventory = sceneInventory;
            debugLog("[pathways] inventory count", this.sceneInventory.length);
        } catch (error) {
            console.error("Error fetching scene inventory: ", error);
        } finally {
            this.inventoryLoadPromise = null;
        }
    }
    async fetchSceneInventory(): Promise<SceneInventoryItem[]>{
        const querySnapshot = await getDocs(collection(db, "scene_metadata"));
        const sceneInventory: SceneInventoryItem[] = [];
        querySnapshot.forEach((doc: QueryDocumentSnapshot<DocumentData>) => {
        sceneInventory.push({ id: doc.id, ...doc.data() } as SceneInventoryItem);
        });
        return sceneInventory;
    }
    //SPRITES 3D
    async populateLandingPage(sceneInventory: SceneInventoryItem[]){
        debugLog("[pathways] populate landing page", sceneInventory?.length ?? 0);
        this.loadedPathways = true;
        const centerObj = new THREE.Object3D();
        if(sceneInventory){
            for (const pathway of sceneInventory) {
                pathway.role = "Path";
                const pathwayItem = new PathwayItem(pathway);
                const item = await pathwayItem.create();
                await this.experience.connectionManager.positionConnection(item, centerObj, 25, 25);
                if(item?.userData?.forkID){
                    this.scene.children.forEach((child: THREE.Object3D) => {
                        if(child.name === 'pathwayItem' && child.userData.id == item.userData.forkID){
                            debugLog("found pioneer path" , child, "forked path", item);
                            item.position.copy(child.position)
                            item.position.x += (Math.random() - 0.5) * 0.8;
                            item.position.y += (Math.random() - 0.5) * 0.8;
                            item.position.z += (Math.random() - 0.5) * 0.8;
                        }
                    })
                }
            }
            debugLog("all pathway items created");
        }
    }
    togglePathSprites()
    {
        this.scene.children.forEach((child: THREE.Object3D)=>{
         if(child?.name === "pathwayItem"){
            child.visible = !child.visible;
         }
     })
    }
}